var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.799 16.4999V14.7777C11.799 13.8642 11.5014 12.9881 10.9716 12.3421C10.4419 11.6961 9.72339 11.3333 8.97422 11.3333H3.32474C2.57557 11.3333 1.85709 11.6961 1.32735 12.3421C0.797606 12.9881 0.5 13.8642 0.5 14.7777V16.4999",
    stroke: "#FF5400",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.14952 7.8889C7.70959 7.8889 8.97427 6.34677 8.97427 4.44445C8.97427 2.54213 7.70959 1 6.14952 1C4.58946 1 3.32478 2.54213 3.32478 4.44445C3.32478 6.34677 4.58946 7.8889 6.14952 7.8889Z",
    stroke: "#FF5400",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0359 16.4999V14.7777C16.0355 14.0145 15.8272 13.2731 15.4437 12.67C15.0603 12.0668 14.5234 11.636 13.9174 11.4452",
    stroke: "#FF5400",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0926 1.11194C11.7002 1.30164 12.2388 1.73254 12.6234 2.33671C13.0079 2.94087 13.2167 3.68394 13.2167 4.44875C13.2167 5.21357 13.0079 5.95663 12.6234 6.56079C12.2388 7.16496 11.7002 7.59586 11.0926 7.78556",
    stroke: "#FF5400",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.b2a590a0863ba713149ca4b0452d1d61.svg";
export { ForwardRef as ReactComponent };